import { Link, createFileRoute } from '@tanstack/react-router';
import { type ColumnDef, type Row, type VisibilityState, getCoreRowModel, getFacetedRowModel, getFacetedUniqueValues, getFilteredRowModel, getPaginationRowModel, getSortedRowModel, useReactTable } from '@tanstack/react-table';
import { useState } from 'react';
import ActionButton from '@/components/Button/ActionButton';
import { DataTable, simpleTextColumn, useTableDisplayState } from '@/components/DataTable';
import { FillScreen, HStack } from '@/components/Layout';
import { defaultNS, useTranslation } from '@/lib/i18n';
import ActionsColumn from '@/routes/_staff/person/$id/_profile/devices/-columns/ActionsColumn';
import CellDeviceColumn from '@/routes/_staff/person/$id/_profile/devices/-columns/CellDeviceColumn';
import CheckBoxColumn from '@/routes/_staff/person/$id/_profile/devices/-columns/CheckBoxColumn';
import { DateColumn } from '@/routes/_staff/person/$id/_profile/devices/-columns/DateColumn';
import { useDevices } from '@/routes/_staff/person/$id/_profile/devices/-query/useDevices';
import type { PeopleDevicesTableRow } from '@/routes/_staff/person/$id/_profile/devices/-type';
export const Route = createFileRoute('/_staff/person/alumni/$id/_profile/devices/')({
  component: PeopleDevices
});
function PeopleDevices() {
  const {
    data: devices,
    isPending
  } = useDevices(Route.useParams().id);
  const [checkedRows, setCheckedRows] = useState<{
    deviceId: string;
  }[]>([]);
  const [columnVisibility, setColumnVisibility] = useState<VisibilityState>({});
  const columns: ColumnDef<PeopleDevicesTableRow>[] = [CheckBoxColumn('selectable', {}, checkedRows, setCheckedRows), CellDeviceColumn('device', {
    i18nKey: 'device',
    sortable: false,
    minWidth: '240px'
  }), simpleTextColumn('device.model', {
    i18nKey: 'model',
    sortable: false,
    minWidth: '240px'
  }), simpleTextColumn('computer.ram', {
    i18nKey: 'ram',
    sortable: false
  }), simpleTextColumn('computer.storage', {
    i18nKey: 'storage',
    sortable: false
  }), simpleTextColumn('monitor.displaySize', {
    i18nKey: 'displaySize',
    sortable: false
  }), simpleTextColumn('fixedAsset.assetTag', {
    i18nKey: 'assetTag',
    sortable: false
  }), DateColumn('user.assignedDate', {
    i18nKey: 'assignedDate',
    sortable: false
  }), DateColumn('procurementDate', {
    i18nKey: 'procurementDate',
    sortable: false
  }), simpleTextColumn('mdmTypeLabel', {
    i18nKey: 'mdmApp',
    sortable: false
  }),
  // TODO: sim バックエンド未対応
  simpleTextColumn('sim', {
    i18nKey: 'sim',
    sortable: false
  }), ActionsColumn('actions')];
  const table = useReactTable({
    data: devices,
    // pageCount,
    columns: columns,
    initialState: {
      columnPinning: {
        left: ['selectable'],
        right: ['actions']
      }
    },
    state: {
      columnVisibility
    },
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    onColumnVisibilityChange: setColumnVisibility,
    manualPagination: true,
    manualSorting: true
  });
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.person.devices'
  });
  const displayState = useTableDisplayState(isPending, devices);
  const navigate = Route.useNavigate();
  const handleRowClick = (row: Row<PeopleDevicesTableRow>) => {
    const deviceId = row.original.device?.id;
    if (!deviceId) return;
    navigate({
      to: '/devices/$id',
      params: {
        id: deviceId
      }
    });
  };
  return <FillScreen className="flex flex-col gap-4 px-12 py-6">
      <HStack className="justify-end gap-2">
        {/* TODO: 未実装 */}
        <Link to="/software/library" disabled>
          <ActionButton className="gap-2" size="sm" variant="outline" icon="UserRoundMinusIcon" iconColor="active" disabled>
            {t('unassignButton')}
          </ActionButton>
        </Link>

        {/* TODO: 未実装 */}
        <Link to="/software/library" disabled>
          <ActionButton className="gap-2" size="sm" variant="outline" icon="UserRoundPlusIcon" iconColor="active" disabled>
            {t('assignButton')}
          </ActionButton>
        </Link>
      </HStack>
      <DataTable table={table} displayState={displayState} onRowClick={handleRowClick} />
      {/* <DataTablePagination table={table} /> */}
    </FillScreen>;
}